import { driver } from 'driver.js';

const driverObj = driver({});

export const highlight = driverObj.highlight;

export const destroy = driverObj.destroy;
